module.exports = __webpack_public_path__ + "img/451002.eeb672aa.png";